module.exports = __webpack_public_path__ + "static/media/Programming.e41d6021.svg";